<script lang="ts">
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    import { getContext, onMount } from 'svelte';
    import Esi from '@shared/components/esi/Esi.svelte';
    import type { BenefitCinemaState } from '@tilelist/components/ProviderComposition.svelte.ts';
    import {
        type KuvoPosition,
        kuvoAttributes,
    } from '@tilelist/domain/external-data-attributes/ExternalDataAttributes.ts';
    import { BENEFIT_CINEMA_CONTEXT } from './BenefitCinemaStore.svelte.ts';

    interface Props {
        dreson: string;
        position: KuvoPosition;
        tilelistSlotIndex?: number;
        featureIndex?: number;
    }

    let { dreson, position, tilelistSlotIndex, featureIndex }: Props = $props();

    const store = getContext<BenefitCinemaState>(BENEFIT_CINEMA_CONTEXT);

    if (import.meta.env.DEV && !store) {
        throw new Error('[BenefitCinema] Must be rendered inside BenefitCinemaProvider');
    }

    /**
 *
 *
 *
 *
 */
    const dataAttributes = $derived(
        position === 'top'
            ? kuvoAttributes({ position })
            : tilelistSlotIndex !== undefined && featureIndex !== undefined
              ? kuvoAttributes({ position, tilelistSlotIndex, featureIndex })
              : {},
    );

    /*                                     */
    /**
 *
 *
 */
    const src = `/benefit-cinema/cinema/productlist?dreson=${encodeURIComponent(dreson)}`;

    let container: HTMLElement | undefined;

    /**
 *
 *
 *
 *
 */
    let clientHasRendered = $state(false);

    onMount(() => {
        if (position !== 'top' || !container) return;
        const html = container.innerHTML.trim();
        /*                                                                              */
        if (html && !html.includes('<esi:include')) {
            store.initFromServer(html);
        }
    });

    /**
 *
 *
 *
 *
 *
 *
 */
    let initialSeedConsumed = false;

    /*                                                                       */
    /*                                                                         */
    $effect(() => {
        const html = store.html;

        if (position === 'top' && !initialSeedConsumed) {
            initialSeedConsumed = true;
            return;
        }

        if (!container || !html) {
            /**
 *
 *
 *
 *
 */
            if (position === 'list' || clientHasRendered) {
                clearContainer();
            }
            return;
        }

        clientHasRendered = true;

        /*                                                                              */
        const range = document.createRange();
        range.selectNodeContents(container);
        const fragment = range.createContextualFragment(html);
        range.deleteContents();
        range.insertNode(fragment);
    });

    function clearContainer() {
        if (!container) {
            return;
        }
        const range = document.createRange();
        range.selectNodeContents(container);
        range.deleteContents();
    }
</script>

<div bind:this={container} class="reptile-benefit-cinema" {...dataAttributes}>
    <!--
        Only the top position renders an ESI include (one SSR request total).
        List positions render an empty container and clone the HTML from the store client-side.
        After the initial fetch resolves, both positions respond to store updates identically.
        BenefitCinemaStore deduplicates client-side fetches with race-condition protection
        via monotonic request IDs, so all positions share one response.
    -->
    {#if position === 'top'}
        <Esi {src} />
    {/if}
</div>

<style lang="scss">
    .reptile-benefit-cinema {
        grid-column: 1 / -1;
        width: 100%;

        &:not(:has(*)) {
            display: none;
        }
    }
</style>
